import React from 'react';
import { motion } from 'framer-motion';
export function Process() {
  const steps = [{
    num: '1',
    title: 'Request Your Free Quote',
    copy: "Submit the short form or call Kosin's Glass."
  }, {
    num: '2',
    title: 'Confirm Vehicle & Glass Details',
    copy: 'The team confirms your vehicle, glass type, damage and insurance information.'
  }, {
    num: '3',
    title: 'Repair, Replace & Calibrate If Needed',
    copy: 'Certified technicians complete the glass service and ADAS calibration if required.'
  }, {
    num: '4',
    title: 'Drive Away With a Clear View',
    copy: 'Leave with professional installation, warranty protection and a safer view of the road.'
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-155">
            How Your Auto Glass Quote Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-156">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-slate-100 -z-10" data-id="element-157"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="relative text-center" data-id="element-158">
              <div className="w-16 h-16 mx-auto bg-white border-4 border-brand-light rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-159">
                <span className="text-2xl font-bold text-brand-blue" data-id="element-160">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-161">
                {step.title}
              </h3>
              <p className="text-slate-600" data-id="element-162">{step.copy}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}